import { get } from "lodash";
import { SCREENS } from "utils/constants";

export const GO_TO_SUBSCRIPTION = "goToSubscription";

export const isGoToSubscriptionBinding = (binding) =>
  get(binding, "action") === GO_TO_SUBSCRIPTION ||
  get(binding, "name") === GO_TO_SUBSCRIPTION;

export const quotedPlanId = (binding, project) =>
  get(binding, "item.id") ||
  get(binding, "insurancePlanId") ||
  get(project, "fields.selectedPlan") ||
  "";

export const existingQuotedSubscriptionId = (
  project,
  planId,
  itemSubscriptionId,
) => {
  if (itemSubscriptionId) return itemSubscriptionId;
  const subscriptions = get(project, "fields.subscriptions") || {};
  if (planId && subscriptions[planId]) return subscriptions[planId];
  return get(project, "fields.currentSubscription") || "";
};

/** Subscription returned by an `executeField` call, if any. */
export const executedSubscriptionId = (result) => {
  const executed = get(result, "data.executeField");
  if (typeof executed !== "string") return get(executed, "subscription.id");
  try {
    return get(JSON.parse(executed), "subscription.id");
  } catch (_error) {
    return undefined;
  }
};

/**
 * Subscription a screen asked to keep on the canvas. Only `stay: true`
 * counts; any other executor result leaves the broker subscription open.
 */
export const screenStaySubscriptionId = (detail) => {
  if (!detail || detail.stay !== true) return undefined;
  return executedSubscriptionId(detail.result);
};

export const rememberStayQuotedSubscription = (notifiedRef, subscriptionId) => {
  if (!notifiedRef || !subscriptionId) return;
  notifiedRef.current = subscriptionId;
};

export const quotedSubscriptionReadyAction = ({
  stayLocked,
  seeded,
  notifiedId,
  nextId,
}) => {
  if (!seeded) {
    return { open: false, notifiedId: nextId || null };
  }
  if (stayLocked) {
    return { open: false, notifiedId: nextId || notifiedId || null };
  }
  if (!nextId || notifiedId === nextId) {
    return { open: false, notifiedId };
  }
  return { open: true, notifiedId: nextId };
};

export const shouldOpenBrokerSubscription = (pathname) =>
  !String(pathname || "").startsWith(
    SCREENS.PRIVATE.GUEST.PROJECTS.DETAIL.path,
  );
